import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ElementRef,
} from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { InformationDto } from '../../portal-settings/models/InformationDtos';
import jsPDF from 'jspdf';
import { HtmlViewerDownloadService } from '../html-viewer/html-viewer-download-service';

@Component({
  selector: 'tou',
  templateUrl: './tou.component.html',
  styleUrls: ['./tou.component.scss'],
})
export class TouComponent implements OnInit {
  tou: string = '';
  touDisplayName: string = '';

  @Input() ShowCloseButton = true;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly generalService: GeneralService,
    private readonly downloadService: HtmlViewerDownloadService,
  ) {}

  @Output() Print = new EventEmitter();
  @Output() Reject = new EventEmitter();
  @Output() Accept = new EventEmitter();

  PrintTOU(elementRef: ElementRef<any>) {
    const pageFormat = 'a4';
    const pageOrient = 'p';

    const pdfDoc = new jsPDF();
    const topMargin = 15;
    const bottomMargin = 15;
    const leftMargin = 5;
    const rightMargin = 5;
    const windowWidthMargin = 20;
    const pageWidth =
      pdfDoc.internal.pageSize.width - (leftMargin + rightMargin);
    const clonedDoc = elementRef.nativeElement
      .getElementsByClassName('ql-container')[0]
      .cloneNode(true);

    // bug: if document created from HTML is > 1 page, adobe reader reports page errors starting with page 2
    // fix: manually add pages that would exist if HTML is rendered (must be added before rendering the HTML!)
    // ugly soluton: render document once, count pages, render again with the required pages added beforehand

    clonedDoc
      .querySelectorAll('*')
      .forEach(
        (el: {
          style: { fontFamily: string; width: string; fontSize: string };
        }) => {
          el.style.fontFamily = 'Helvetica'; // setting it to the default font of jspdf to space out the text correctly
          el.style.width = '100%'; // setting width to fill the full portrait page width
          el.style.fontSize = '14px'; // setting font size to fill the full portrait page width and height
        },
      );

    new jsPDF('p', 'pt', 'letter').html(clonedDoc.childNodes[0], {
      autoPaging: 'text',
      margin: [topMargin, rightMargin, bottomMargin, leftMargin],
      width: pageWidth,
      windowWidth: elementRef.nativeElement.getBoundingClientRect().width,
      callback: (res) => {
        // add pages that are required by the rendered HTML (start with page 2)
        for (let i = 2, j = res.getNumberOfPages(); i <= j; i++) {
          pdfDoc.addPage(pageFormat, pageOrient);
        }

        // render document properly
        pdfDoc.html(clonedDoc.childNodes[0], {
          autoPaging: 'text',
          margin: [topMargin, rightMargin, bottomMargin, leftMargin],
          width: pageWidth,
          windowWidth:
            elementRef.nativeElement.getBoundingClientRect().width -
            windowWidthMargin,
          callback: (doc) => {
            const pdfUrl = doc.output('bloburl');
            window.open(pdfUrl, '_blank');
          },
        });
      },
    });
  }
  StartPdfGeneration() {
    this.downloadService.requestdownload();
  }
  RejectTOU() {
    this.Reject.emit();
  }

  AcceptTOU() {
    this.Accept.emit();
  }

  ngOnInit() {
    this.generalService
      .GetInformationByName(['Terms of Use'])
      .then((response: InformationDto[]) => {
        if (response && response.length > 0 && response[0]) {
          this.tou = decodeURIComponent(response[0].content ?? '');
          this.touDisplayName = decodeURIComponent(
            response[0].displayName ?? '',
          );
        }
        this.cdr.detectChanges();
      });
  }
}
